import React from 'react';
import withQuillLayout from 'src/_common/hoc/QuillLayout';
import AboutComponent from 'src/mics/components/About';

function About() {
  return <AboutComponent />;
}

export default withQuillLayout({
  children: About,
});
